import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Contact = () => {
  return (
    <React.Fragment>
      <SEO title="Contact | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Contact"
        content="The Conference"
        contentTwo="Contact"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
          <div className="contact">
            <h3 className="entry-title">ICSI Conference Secretariat</h3>
            <li>
              <img src="./images/icons/person.png" width="20px"/>
              <b>	&nbsp;Contact person:</b> Mr. Yulong Sha
            </li>
            <li>
            <img src="./images/icons/email.png" width="20px"/>
              <b> &nbsp;Email:</b>{" "}
              <a href="mailto: icsi2026@iasei.org">icsi2026@iasei.org</a>
            </li>
            {/* <li>
            <img src="./images/icons/call.png" width="20px"/>
              <b> &nbsp;TEL.:</b> +86-13263235833
            </li> */}
            <li>
            <img src="./images/icons/twitter.png" width="20px"/>
              <a href="https://twitter.com/IASEI_ICSI"><b> &nbsp;Twitter:</b> @IASEI_ICSI </a>
            </li>
          
      
            <li></li>
          </div>
        <div className="entry-content">
          <table className="wechat">
            <thead>
              <tr>
                <th>WeChat: ICSI_Secretariat</th>
                {/* <th>WeChat Group for participants: </th> */}
                <th>WeChat Subscription: 国际群体智能会议ICSI</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <img
                    src="./images/contact/wechat.jpg"
                    className="header-image"
                    alt="ICSI 2026"
                    width="250px"
                  />
                </td>
                  {/* <td>
                  <object className="wechat-svg" data="./images/svg/arrow.svg" type="image/svg+xml"></object>

                    <h4 className="wechat">Add this WeChat and you will be pulled into the WeChat group</h4>
                  </td> */}
                <td>
                  <img
                    src="./images/contact/wechat-subscription.jpg"
                    className="header-image"
                    alt="ICSI 2026"
                    width="250px"
                  />
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Contact;
